import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import WeeklyBreakdownTableRow from './WeeklyBreakdownTableRow'
import {WeeklyBreakdownTableProps} from '../../types'
import {weeklyBreakdownColumns} from '../../utils'

const WeeklyBreakdownTable = ({data, loading = false}: WeeklyBreakdownTableProps) => {
  return (
    <DynamicTable
      data={data}
      sortableColumns={weeklyBreakdownColumns}
      TableRow={WeeklyBreakdownTableRow}
      loading={loading}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      noDataMessage='No weekly breakdown data available'
    />
  )
}

export default WeeklyBreakdownTable
